import { map, set, size, unset } from "lodash";
import { startOfDay, endOfDay, fromUnixTime } from "date-fns";
import api from "../../services/api";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { formatRequestDatetime, isToday } from "../../utils/dateFns";

export const getPropostas = (
  filters,
  pageSize,
  orderByColumn,
  orderDirection
) => {
  const {
    numeroProposta,
    pedidoId,
    selectedConvenio,
    selectedLoja,
    selectedCarteira,
    selectedProduto,
    selectedStatus,
    selectedSituacoes,
    selectedAnalista,
    numeroCpf,
    dataInicio,
    dataFim,
    page,
    ...other
  } = filters;
  const params = {
    ...other,
    pageable: {
      page,
      size: pageSize || 20,
    },
  };
  unset(params, "key");

  if (numeroProposta) set(params, "numeroProposta", numeroProposta);
  if (pedidoId) set(params, "pedidoId", pedidoId);
  if (numeroCpf) set(params, "numeroCpf", desmaskIfNumber(numeroCpf));
  if (selectedConvenio) set(params, "codigoConvenio", selectedConvenio.codigo);
  if (selectedLoja) set(params, "codigoLoja", selectedLoja.codigoFilial);
  if (selectedCarteira) set(params, "codigoCarteira", selectedCarteira.codigo);
  if (selectedProduto && selectedProduto.codigo)
    set(params, "codigoProduto", selectedProduto.codigo);
  if (selectedAnalista && selectedAnalista.codigo)
    set(params, "numeroAnalista", selectedAnalista.codigo);
  if (selectedStatus) set(params, "codigoStatus", selectedStatus.numero);
  if (size(selectedSituacoes) > 0)
    set(
      params,
      "situacaoIds",
      map(selectedSituacoes, (it) => it.id)
    );
  if (dataInicio) {
    set(
      params,
      "dataInicio",
      formatRequestDatetime(startOfDay(fromUnixTime(dataInicio)))
    );
  }
  if (dataFim) {
    const data = fromUnixTime(dataFim);
    if (isToday(data)) {
      data.setTime(new Date().getTime());
      set(params, "dataFim", formatRequestDatetime(data));
    } else {
      set(
        params,
        "dataFim",
        formatRequestDatetime(endOfDay(fromUnixTime(dataFim)))
      );
    }
  }
  if (orderByColumn) set(params, "pageable.sortColumn", orderByColumn);
  if (orderDirection) set(params, "pageable.sortDirection", orderDirection);

  // const parsedParams = new URLSearchParams(params).toString();
  return api.post("api/front-credito/propostas", params);
};
